import { createFileRoute } from '@tanstack/react-router';

import {
  bankAccountMedInformationScreen,
  accountMedSearch,
  loadBankAccountMessages,
  loadBankAccountScreens,
} from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute(
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes',
)({
  validateSearch: accountMedSearch,
  staticData: { screen: bankAccountMedInformationScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountMedInformationScreen'),
});
